import { render, staticRenderFns } from "./ErrorAutenticate.vue?vue&type=template&id=23233152&scoped=true&lang=pug&"
import script from "./ErrorAutenticate.vue?vue&type=script&lang=js&"
export * from "./ErrorAutenticate.vue?vue&type=script&lang=js&"
import style0 from "./ErrorAutenticate.vue?vue&type=style&index=0&id=23233152&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23233152",
  null
  
)

export default component.exports